import { render, staticRenderFns } from "./AdSpacesFilters.vue?vue&type=template&id=436b72cf&scoped=true&"
import script from "./AdSpacesFilters.vue?vue&type=script&lang=ts&"
export * from "./AdSpacesFilters.vue?vue&type=script&lang=ts&"
import style0 from "./AdSpacesFilters.vue?vue&type=style&index=0&id=436b72cf&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "436b72cf",
  null
  
)

export default component.exports